module.exports = "/matchcenter-staging/assets/images/ert_2.11cac8cbef7d9cbbbac148ae0094a13f.png";